module.exports = __webpack_public_path__ + "img/no_image.2ffda763.png";